"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validation = void 0;
/**
 * @summary Creates a new validation.
 *
 * Creates a new validation.
 *
 * @param {string} message
 * @param {function} validate
 * @returns {Validation}
 */
function validation(message, validate) {
    return {
        message,
        validate,
    };
}
exports.validation = validation;
